var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm._t("default", function () {
        return [
          _c(
            "div",
            {
              staticClass:
                "btn-group-toggle draw-interactions text-center w-100",
              class: { "btn-group": _vm.groupControls },
              attrs: { "aria-label": "Draw Controls" },
            },
            _vm._l(_vm.drawControls, function (control) {
              return _c(
                "label",
                {
                  key: `control-${_vm.id}-${control.id}`,
                  staticClass: "btn btn-outline-main min-w-auto",
                  class: [
                    { active: control.id === _vm.drawControlId },
                    { disabled: _vm.isControlDisabled(control.id) },
                    control.class ? control.class : "",
                  ],
                  attrs: {
                    for: `control-${_vm.id}-${control.id}`,
                    title: control.label,
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drawControlId,
                        expression: "drawControlId",
                      },
                    ],
                    attrs: {
                      type: "radio",
                      name: `toogle-draw-${_vm.id}`,
                      id: `control-${_vm.id}-${control.id}`,
                      disabled: _vm.isControlDisabled(control.id),
                      autocomplete: "off",
                    },
                    domProps: {
                      value: control.id,
                      checked: _vm._q(_vm.drawControlId, control.id),
                    },
                    on: {
                      change: function ($event) {
                        _vm.drawControlId = control.id
                      },
                    },
                  }),
                  _vm._v(" "),
                  control.image
                    ? _c("img", {
                        attrs: { src: _vm.assetsPathModule(control.image) },
                      })
                    : control.icon
                    ? _c("i", { class: control.icon })
                    : _c("span", [_vm._v(" " + _vm._s(control.label) + " ")]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("ul", { staticClass: "small pl-3 mb-0" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("li", [
                  _c("code", [_vm._v("Snap")]),
                  _vm._v(
                    " activo enquanto desenha " +
                      _vm._s(_vm.enableModify ? "ou modifica" : "") +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _vm.showSelect
                  ? _c("li", [
                      _vm._v(
                        "\n                        Selecione a geometria para "
                      ),
                      _c("code", [_vm._v("modificar")]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSelect
                  ? _c("li", [
                      _c("code", [_vm._v("Delete")]),
                      _vm._v(" para eliminar geometria\n                    "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.enableModify
                  ? _c("li", [
                      _c("code", [_vm._v("Alt+Click")]),
                      _vm._v(" para apagar vértice\n                    "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showHelpLimit
                  ? _c("li", [
                      _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            `Possivel adicionar no mínimo ${_vm.minFeatures} e máximo ${_vm.maxFeatures} elementos.`
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("code", [_vm._v("Double Click")]),
      _vm._v(" para terminar o desenho\n                    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }